/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */

import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalConfirmacionTurno.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';

// import MonitoringUtil from '../../../utils/monitoringUtil.js';

class ModalConfirmacionTurno extends React.Component {
  constructor(props) {
    super(props);
    this.onButtonAgendarClick = this.onButtonAgendarClick.bind(this);

    // this.monitoringUtil = new MonitoringUtil();
  }

  onButtonAgendarClick() {
    this.props.closeModal();

    // Monitoring log
    /*
    this.monitoringUtil.createAffilliateLog({
      interaction: 'SOLICITUD DE TURNOS - POP-UP CONFIRMACION DE TURNO',
      message: `El afiliado tomo un turno el dia ${this.props
        .displayDate} con el medico ${this.props.nombre} ${this.props
        .apellido}`,
    }); */

    this.props.confirmarTurno(this.props.dataTurno, this.props.email);
  }

  render() {
    const urlImage = 'smgnewsite/images/telemedicina/';
    const img = `${urlImage}${this.props.prestadorId}.jpg`;
    const imgDefault = `${urlImage}sin_foto.jpg`;
    return (
      <Modal isOpen={this.props.show} toggle={this.props.closeModal}>
        <ModalHeader
          toggle={this.props.closeModal}
          className={`${s.robotoMedium}`}
        >
          Confirmación de Turno
        </ModalHeader>
        <ModalBody>
          <img
            id={this.props.prestadorId}
            style={{
              borderRadius: '50%',
              width: '100px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
            }}
            className="align-self-center"
            src={img}
            alt="Medico"
            onError={() => {
              $(`${this.props.prestadorId}`).attr('src', imgDefault);
            }}
          />
          <div className={`${s.robotoMedium} text-center`}>
            {`${this.props.nombre} ${this.props.apellido}`}
          </div>
          <div
            style={{ marginBottom: '10px' }}
            className={`${s.robotoMedium} text-center`}
          >
            {$('#especialidad option:selected').text()}
          </div>
          <div style={{ padding: '0px 50px' }}>
            <div style={{ marginBottom: '10px' }} className="text-left">
              <strong> Dia y Hora:</strong> {this.props.displayDate}
            </div>
            <div style={{ marginBottom: '5px' }} className="text-left">
              Se enviar&aacute; confirmaci&oacute;n de turno{' '}
            </div>

            <div className="text-left">al siguiente email:</div>
            <br />
            <div className={`${s.innerAddon} ${s.leftAddon}`}>
              <i className="fa fa-envelope-o" aria-hidden="true" />
              <input
                defaultValue={this.props.email}
                type="email"
                id="email"
                className="form-control"
                placeholder="Dirección de correo electrónico"
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-4">
                <button
                  onClick={this.props.closeModal}
                  data-dismiss="modal"
                  className={`${s.boton_blanco} ${s.robotoMedium} btn btn-default float-left`}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-lg-4" />
              <div className="col-lg-4">
                <button
                  className={`${s.boton_rojo} ${s.robotoMedium}  btn btn-danger float-right`}
                  onClick={e => this.onButtonAgendarClick(e)}
                >
                  Agendar
                </button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(null, telemedicinaActions)(
  withStyles(s)(ModalConfirmacionTurno),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalConfirmacionTurno/ModalConfirmacionTurno.js